// Types for trials go here

import { TrialLinkStatus, TrialStatus } from '@lemans/shared';

export interface TrialsState {
  bundles: TrialBundle[];
  reservation?: TrialReservation;
  refreshGrid: boolean;
}

export interface ReservationInfo {
  campaignId: string;
  trialReservationId: string;
}

export interface RedeemTrial {
  campaignId: string;
  trialReservationId: string;
  trialReservationDetails: TrialReservation;
}

export interface TrialBundle {
  id: string;
  name: string;
  description: string;
  credits: string;
  products: Product[];
}

export interface AllocateTrial {
  userId: string;
  trialId: string;
  tenantId: string;
  tenantName: string;
  trialBundle: TrialBundle;
}
export interface TrialReservation {
  id: string;
  campaignId: string;
  status: TrialLinkStatus;
  campaignBundleId: string;
  durationInDays: number;
  expiresOn?: string;
  campaignType: CampaignType;
}

export type CampaignType = 'user' | 'organization';

export interface Product {
  catalog: string;
  quantity: number;
}

export function productToString(product: Product): string {
  return `${product.catalog} (${product.quantity})`;
}

export interface DomainResponseAction {
  case: string;
  serviceKind: string;
  catalogCode: string;
}

export interface DomainResponseDataForTrialWithCSP {
  action: DomainResponseAction;
}

export interface Trial {
  id: string;
  partitionId: string;
  viewType: string;
  expiresOn: Date;
  redeemedOn: Date;
  status: TrialStatus;
  credits: string;
  remainingCredits: number;
  consumedCredits: number;
  tenantId: string;
  campaignBundleId: string;
  campaignBundle?: TrialBundle;
  allocatedOn?: Date;
  hasCredits: string;
  trialType: CampaignType;
}
